import { __callbacks } from "Utils/Callbacks/Callback";
import { __utils } from "Utils/Utils";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./New.module.scss";
import { MessageNumber } from "../Utils/MessageNumber";
import { ConversationID } from "../Utils/ConversationID";
import MessageSend from "components/ChatApp/components/ChatMessage/components/MessageSend/MessageSend";
import ChatMessage from "components/ChatApp/components/ChatMessage/ChatMessage";
import Text from "components/ChatApp/components/ChatMessage/components/Text/Text";
import MessageNotify from "components/ChatApp/components/ChatMessage/components/MessageNotify/MessageNotify";
import Form from "components/ChatApp/components/ChatMessage/components/Form/Form";
import MessageTemporary from "components/ChatApp/components/ChatMessage/components/MessageTemporary/MessageTemporary";
import NewChat from "components/ChatApp/components/ChatMessage/components/MessageTemporary/components/NewChat/NewChat";
import MessageReceive from "components/ChatApp/components/ChatMessage/components/MessageReceive/MessageReceive";
import { IChatMsgAPI, IUnreadMsg } from "Utils/Interfaces";
import FileUpload from "components/ChatApp/components/ChatMessage/components/FileUpload/FileUpload";
import { __map } from "Utils/Map/Map";
import { __chatState } from "Utils/Chats/ChatState";
import { __chats } from "Utils/Chats/Chats";
import { __chatQueue } from "Utils/ChatQueue/ChatQueue";
import React from "react";
import { MsgFragmentNewChild } from "Utils/Chats/MsgFragmentNewChild";
import Quiz from "components/ChatApp/components/ChatMessage/components/Quiz/Quiz";
import CustomLayout from "components/ChatApp/components/ChatMessage/components/CustomLayout/CustomLayout";
import CustomForm from "components/ChatApp/components/ChatMessage/components/CustomForm/Form";
import Image from "components/ChatApp/components/ChatMessage/components/Image/Image";
import Navigation from "components/ChatApp/components/ChatMessage/components/Navigation/Navigation";




const components = {
  Text,
  MessageNotify,
  MessageSend,
  MessageReceive,
  Form,
  FileUpload,
  Quiz,
  CustomLayout,
  Image,
  Navigation,
  CustomForm
}


const callbackIds = {
  chatInputSubmit: "",
  userOption: "",
  onBotResponse: "",
  onFileUpload: "",
  onUnreadMsgs: ""
};

const chat = {
  reset: false
}

const currentMsg = {
  messageNo: 0
};



export default function New() {

  const container = useRef(null);
  const [conversationId,] = useState(new ConversationID());
  const [messageNo,] = useState(new MessageNumber());
  const [content, setContent] = useState<any[]>([]);


  const reset = useCallback(
    /**
     * resets the chat state
     */
    () => {
      setContent(arr => {
        const newArr: any[] = [];
        arr.forEach(el => {
          const isTemporary = (el.props.children.type === MessageTemporary);
          if (!isTemporary) newArr.push(el);
        })
        return [...newArr];
      });
      messageNo.reset();
    },
    [messageNo]
  );
  const getProps = useCallback(
    /**
     * returns object of common props
     * @returns {object} props
     */
    () => {
      return { conversationId: conversationId.get(), messageNo: messageNo.get() };
    },
    [conversationId, messageNo]
  );
  const push = useCallback(
    /**
     * pushes the new message in the chat
     * @param element any
     */
    (element: any) => {
      messageNo.increment();
      setContent(arr => [...arr, <ChatMessage key={__utils.getUuidv4()}>{element}</ChatMessage>]);
    },
    [messageNo],
  );

  const handleChatReset = useCallback(
    () => {
      if (!chat.reset) {
        reset();
        chat.reset = true;
        // disable inputs
        __callbacks.disableChatInputs.trigger({ chatId: conversationId.get() });
      }
    },
    [reset, conversationId],
  )
  

  const initFileUploadEvents = useCallback(
    () => {
      /**
       * file uplad event
       * 
       */
      callbackIds.onFileUpload = __callbacks.onFileUpload((fileData: any) => {

        //check if inputs are disabled
        if (__chatState.get(conversationId.get())?.disableInputs) {
          __callbacks.userNotification.trigger("Please follow the instructions of the chat! (Inputs are disabled).");
          return;
        }

        // reset the chat
        handleChatReset();

        __callbacks.messageFragment.trigger({
          newChild: {
            messageType: "MessageSend",
            fragmentType: "FileUpload",
            props: {
              messageType: "MessageSend",
              ...__map.mapFileData(fileData),
              fileData: fileData,
              ...getProps(),
              messageNo: currentMsg.messageNo
            }
          }
        })
          .onEmpty(() => {
            const { messageNo } = getProps();
            currentMsg.messageNo = messageNo;
            push(<MessageSend {...getProps()}>{[<FileUpload key={__utils.getRandomIdShort()} {...getProps()} type={"FileUpload"} {...__map.mapFileData(fileData)} fileData={fileData} messageType="MessageSend" id={__utils.getUuidv4()}></FileUpload>]}</MessageSend>);
          });
      });
      //--------------------------
    },
    [getProps, push, handleChatReset, conversationId],
  );

  const initListeners = useCallback(
    /**
     * initializes the events
     */
    () => {
      // chat input ---------------------------------------------------
      callbackIds.chatInputSubmit = __callbacks.onChatInputSubmit((data: any) => {
        // got the chat input
        handleChatReset();

        __callbacks.setChatHeaderSmall.trigger({ data: "set chat header to small" });

        __callbacks.messageFragment.trigger({
          newChild: {
            messageType: "MessageSend",
            fragmentType: "Text",
            props: {
              text: data.textAreaValue
            }
          }
        })
          .onEmpty(() => {
            const { messageNo } = getProps();
            currentMsg.messageNo = messageNo;
            push(<MessageSend {...getProps()}>{[<Text key={__utils.getRandomIdShort()} type={"Text"} text={data.textAreaValue} id={__utils.getUuidv4()}></Text>]}</MessageSend>);
          });
      });
      //--------------------------------------------------------------

      // User options -----------------------------------------------
      callbackIds.userOption = __callbacks.onUserOption((text: string) => {
        //handleChatReset();
        reset();
        chat.reset = true;
        // disable inputs
        __callbacks.disableChatInputs.trigger({ chatId: conversationId.get() });
        push(<MessageSend {...getProps()}>{[<Text key={__utils.getRandomIdShort()} type={"Text"} text={text} id={__utils.getUuidv4()}></Text>]}</MessageSend>);
      });
      //--------------------------------------------------------------

      //initBotListener();
      initFileUploadEvents();

      // push user options------
      // 1. greeting msg
      // 2. just browsing (option).
      // 3. learn more (option).
      // 4. I have a question (option).
      push(<MessageTemporary><NewChat></NewChat></MessageTemporary>);
      // ------------------------------------------------------------

    },
    [push, getProps, initFileUploadEvents, handleChatReset, reset, conversationId],
  );

  useEffect(() => {
    initListeners();
  }, [initListeners]);


  useEffect(() => {
    __callbacks.scrollToBottomChat.trigger({});
  }, [content]);
  
  const resloveChat = useCallback(
    /**
     * resloves unread messages
     * @param chatMsg IChatMsgAPI
     * @returns {void}
     */
    (chatMsg: IChatMsgAPI) => {
      const { userId, userName, userPhoto } = chatMsg;
      const userProps = {
        userId,
        userName,
        userPhoto
      };

      // try the message fragment
      __callbacks.msgFragmentEx.trigger(
        new MsgFragmentNewChild({
          messageType: chatMsg.messageType,
          fragmentType: chatMsg.child.componentName,
          fragment: chatMsg.fragment,
          ...userProps,
          props: { ...chatMsg.child.props },
          ...getProps()
        })
      )
        .onEmpty(() => {
          const elementChild = React.createElement((components as any)[chatMsg.child.componentName], { key: __utils.getRandomIdShort(), ...getProps(), ...chatMsg.child.props, id: __utils.getUuidv4(), type: chatMsg.child.componentName });
          const elementParent = React.createElement((components as any)[chatMsg.messageType], { key: __utils.getRandomIdShort(), time: chatMsg.time, id: __utils.getUuidv4(), ...getProps(), ...userProps }, [elementChild]);
          push(elementParent);
        });

    },
    [push, getProps]
  );
  
  useEffect(() => {
    // listen to unread message
    callbackIds.onUnreadMsgs =  __callbacks.onUnreadMsgs((ureadMsgs: IUnreadMsg) => {
      if(ureadMsgs.chatId !== conversationId.get()) return;

      if(ureadMsgs.unreadMsgs > 0) {
        // got some unread messages 
        const chats = __chatQueue.resolve(conversationId.get());
        chats.forEach((chatMsg: IChatMsgAPI) => {
          resloveChat(chatMsg);
        });
      }
    });
  }, [conversationId, resloveChat]);


  useEffect(() => {
    __chats.setCurrentChatId(conversationId.get());
  }, [conversationId]);


  useEffect(() => {
    // set chat reset to false
    chat.reset = false;

    return () => {
      __callbacks.chatInputSubmit.remove(callbackIds.chatInputSubmit);
      __callbacks.userOption.remove(callbackIds.userOption);
      __callbacks.botResponse.remove(callbackIds.onBotResponse);
      __callbacks.fileUpload.remove(callbackIds.onFileUpload);
      __callbacks.messageFragment.destroyCallback();
      __callbacks.msgFragmentEx.destroyCallback();
      __callbacks.unreadMsgs.remove(callbackIds.onUnreadMsgs);
      currentMsg.messageNo = 0;

      // destroy current chat id
      __chats.setCurrentChatId("");
    }
    
  }, []);

  return (
    <div ref={container} className={styles.container}>{content}</div>

  )
}
